module.exports = [
  {
    title: 'ID',
    key: 'id'
  },
  {
    title: 'Дата передачи',
    key: 'created_date'
  },
  {
    title: 'Название МО',
    key: 'hospital'
  },
  // {
  //   title: 'PatientID',
  //   key: 'patient_id'
  // },
  {
    title: 'Регион',
    key: 'region'
  },
  {
    title: 'Оценка',
    key: 'recommendation'
  },
  {
    title: 'Статус отзыва',
    key: 'status'
  }
]
